import React from "react";

// set the defaults
const FullPageExportContext = React.createContext({
  language: "en",
  setLanguage: () => {}
});

export default FullPageExportContext;
